import { IConnectionLogsFilterOptions } from '@interfaces/middlewareSMO/connectionLogs';

import {
	CONNECTION_LOGS_FIELD_NAMES,
	CONNECTION_LOGS_PLACEHOLDERS,
} from '@components/routes/AdminPanel/ManageMiddlewareSMO/constants';

import { useQueryConnectionLogsFilters } from './useQueryConnectionLogsFilters';

interface IUseConnectionLogsFiltersReturned extends IConnectionLogsFilterOptions {
}

export const useConnectionLogsFilters = (): IUseConnectionLogsFiltersReturned => {
	const {
		users,
		connectionStatuses,
		eventTypes,
		middlewares,
		sources,
		isLoadingUsers,
		isLoadingConnectionStatuses,
		isLoadingEventTypes,
		isLoadingMiddlewares,
		isLoadingSources,
	} = useQueryConnectionLogsFilters();

	const filters = [
		{
			name: CONNECTION_LOGS_FIELD_NAMES.middlewareId,
			placeholder: CONNECTION_LOGS_PLACEHOLDERS.middleware,
			data: middlewares,
		},
		{
			name: CONNECTION_LOGS_FIELD_NAMES.eventType,
			placeholder: CONNECTION_LOGS_PLACEHOLDERS.eventType,
			data: eventTypes,
		},
		{
			name: CONNECTION_LOGS_FIELD_NAMES.connectionStatus,
			placeholder: CONNECTION_LOGS_PLACEHOLDERS.connectionStatus,
			data: connectionStatuses,
		},
		{
			name: CONNECTION_LOGS_FIELD_NAMES.source,
			placeholder: CONNECTION_LOGS_PLACEHOLDERS.source,
			data: sources,
		},
		{
			name: CONNECTION_LOGS_FIELD_NAMES.userId,
			placeholder: CONNECTION_LOGS_PLACEHOLDERS.user,
			data: users,
		},
	];

	const isLoading = (
		isLoadingUsers ||
		isLoadingConnectionStatuses ||
		isLoadingEventTypes ||
		isLoadingMiddlewares ||
		isLoadingSources
	);

	return {
		filters,
		isLoading,
	};
};
